import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const SECRET_KEY = 'YourSecureKeyForRDAWebPortal'; 

function encryptAES(data: string, key: string): string {
    return CryptoJS.AES.encrypt(data, key).toString();
}

function decryptAES(encryptedData: string, key: string): string {
    try {
        const bytes  = CryptoJS.AES.decrypt(encryptedData, key);
        const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
        return decryptedString;
    } catch (e) {
        return '';
    }
}

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  encrypt(data: any): string {
    if (data === null || data === undefined) return '';
    const dataString = typeof data === 'string' ? data : JSON.stringify(data);
    return encryptAES(dataString, SECRET_KEY);
  }
  decrypt<T>(encryptedData: string | null): T | null {
    if (!encryptedData) return null;
    
    const decryptedString = decryptAES(encryptedData, SECRET_KEY);
    if (!decryptedString) return null;
    try {
        const trimmedString = decryptedString.trim();
        if (trimmedString.startsWith('{') || trimmedString.startsWith('[')) {
            return JSON.parse(trimmedString) as T;
        }
        return decryptedString as any; 
    } catch (e) {
        return decryptedString as any;
    }
  }
}